import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { FundListRow } from "./types";

// GET /api/admin/mdf/funds → { funds: FundListRow[] }
//
// Sub-bucket 15 — admin index. The worker aggregates allocated + available +
// open_request_count per fund so the cards render without per-fund
// round-trips. Bare key matches `queryKeys.mdf.funds()` so the
// useCreateFund / useCloseFund / useUpdateFund hooks' invalidations sweep
// this on day one.
export function useFunds() {
  return useQuery<FundListRow[], ApiClientError>({
    queryKey: queryKeys.mdf.funds(),
    queryFn: async () => {
      const body = await apiFetch<{ funds: FundListRow[] }>("/admin/mdf/funds");
      return body.funds;
    },
  });
}
